<template>
  <v-card>
    <v-card-title class="headline py-2">
      Редактировать период
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container grid-list-lg class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 md6>
            <p class="body-2 text-xs-center">Начальная дата</p>
            <v-date-picker v-model="periodFrom" full-width locale="ru-ru" no-title first-day-of-week="1" color="primary"></v-date-picker>
          </v-flex>
          <v-flex xs12 md6>
            <p class="body-2 text-xs-center">Конечная дата</p>
            <v-date-picker v-model="periodTo" full-width locale="ru-ru" no-title first-day-of-week="1" color="primary"></v-date-picker>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit">Сохранить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name : "PeriodForm",
    
    props: {
      from: {
        type : String,
        required : false,
        default: null
      },
      to: {
        type : String,
        required : false,
        default: null
      },
    },
    
    created() {
      this.periodFrom = this.from
      this.periodTo = this.to
    },
    
    data() {
      return {
        periodFrom: null,
        periodTo: null
      }
    },
    
    methods : {
      submit() {
        this.$emit('save', {
          type: 'period',
          data: {
            periodFrom: this.periodFrom,
            periodTo: this.periodTo
          }
        })
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Statistics/Forms/PeriodForm.vue